import { render, staticRenderFns } from "./StepCardOption.vue?vue&type=template&id=1c0a2ee4&scoped=true&"
import script from "./StepCardOption.vue?vue&type=script&lang=js&"
export * from "./StepCardOption.vue?vue&type=script&lang=js&"
import style0 from "./StepCardOption.vue?vue&type=style&index=0&id=1c0a2ee4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a2ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCheckbox,VImg})
